import request from "../../config/axios";

// view cart by 
const getCart = () => {
    return request.get(`/wp-json/custom-cart/v1/view`, {
        withCredentials: true
    })
}


const addToCart = ({ product_id, quantity, variation_id, attributes }) => {

    return request.post(`/wp-json/custom-cart/v1/add`, {
        product_id,
        quantity,
        ...(variation_id && { variation_id }),
        ...(attributes && { attributes })
    }, {
        withCredentials: true
    })
}

const updateCartItem = ({ cart_item_key, quantity }) => {
    return request.post(`/wp-json/custom-cart/v1/update`, {
        cart_item_key,
        quantity
    }, {
        withCredentials: true
    })
}

const removeFromCart = ({ cart_item_key }) => {
    return request.post(`/wp-json/custom-cart/v1/remove`, {
        cart_item_key
    }, {
        withCredentials: true
    })
}

const clearCart = () => {
    return request.post(`/wp-json/custom-cart/v1/clear`, {}, {
        withCredentials: true
    })
}

export { getCart, addToCart, updateCartItem, removeFromCart, clearCart }